import { formatMoney } from '@/lib/format'

import { varianceStatus, varianceWords } from '../lib/pace'

/** `$12.3k under` (good) / `$4.1k over` (bad) / `on budget`. Variance = actual − budget. */
export function VarianceTag({ variance }: { variance: number }) {
  const words = varianceWords(variance)
  if (words === 'on budget') return <span className="tone-good">on budget</span>
  return (
    <span className={`tone-${varianceStatus(variance)}`}>
      {formatMoney(Math.abs(variance), { compact: true })} {words}
    </span>
  )
}
